<hs-content-condition-guard
  [guardedContent]="content"
  contentGuardCardHeader="No Account Selected"
  contentGuardCardMessage="To proceed, please select an account from the 'My Accounts' panel. You can either double-click an account in the 'Aggregates' or 'Portfolios and Simples' list."
  [conditionsMet$]="isAggregateFocused"
>
</hs-content-condition-guard>
